import React, { useEffect, useState } from 'react'
import faradayApi from '../../../../api/faradayApi'
import { PrincipalLayouts } from '../../../../layouts/PrincipalLayouts'
import { AddStartupValoration } from './AddStartupValoration'

export const GetStartupsList = () => {

    const [startupList, setStartupList] = useState('isLoading')
    const getstartupList = async() => {
        const { data } = await faradayApi.get('/startups/getNameList');
        setStartupList(data.data)
    }

    useEffect(() => {
        getstartupList()
    }, [])

    return (
        <PrincipalLayouts>
        {
            startupList !== 'isLoading' &&
            <AddStartupValoration startupList={startupList} />
        }
        </PrincipalLayouts>
    )
}
